import { render } from "./TrayMenu.vue?vue&type=template&id=02842148&scoped=true"
import script from "./TrayMenu.vue?vue&type=script&lang=js"
export * from "./TrayMenu.vue?vue&type=script&lang=js"

import "./TrayMenu.vue?vue&type=style&index=0&id=02842148&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/biology-microscopy/biology-microscopy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02842148"]])

export default __exports__